import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { trackEvent } from "../../helpers";

const Link = ({ url, label, element, children, __typename, type, ...rest }) => {
  switch (type) {
    case "entry":
      return (
        <RouterLink
          to={`/${element.uri === "__home__" ? "" : element.uri}`}
          {...rest}
        >
          {children || label}
        </RouterLink>
      );

    case "asset":
      return (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          {...rest}
          onClick={() => {
            trackEvent({
              category: "Download",
              action: "Download",
              label: element.title || url,
            });
          }}
        >
          {children || label}
        </a>
      );

    default:
      return (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          {...rest}
          onClick={() => {
            trackEvent({
              category: "Outbound",
              action: "Click",
              label: url,
            });
          }}
        >
          {children || label}
        </a>
      );
  }
};

export default Link;
